import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postTemplateFailure,
  postTemplateSuccess,
} from "../slices/features/postTemplate";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postTemplateSaga(action: any) {
  const { payload } = action;
  const { id, data, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.postTemplate,
      baseUrl,
      id,
      data,
      meta
    );
    yield put(postTemplateSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postTemplateFailure({ statusCode, statusText }));
  }
}

export function* watchPostTemplate() {
  yield takeLatest(RequestTypes.POST_TEMPLATE_REQUEST, postTemplateSaga);
}
